import { useState} from 'react'
import CloseIcon from '../../../assets/icons/close.svg?react';
import EditIcon from '../../../assets/icons/edit.svg?react';
import DeleteIcon from '../../../assets/icons/delete.svg?react';

const ChargerDetailModal = ({ onClose, charger }) => {
  
  return (
    <div className="detail-modal-background">
      <div className="detail-modal-container">
        <div className="detail-modal-header">
          <h3>충전기 상세정보</h3>
          <button className='close-btn' onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="detail-modal-content">
          <div className='detail-modal-content-divide-container'>
            <div className='detail-modal-content-divide-content left'>
              {/* LEFT HEADER */}
              <div className='detail-modal-content-divide-content-header flex align-center gap-5'>
                <h3 className='text-b1-700 text-primary'>충전기 정보</h3>
                <button className='btn icon-btn'>
                  <EditIcon color='var(--gray-600)'/>
                </button>
                <button className='btn icon-btn'>
                  <DeleteIcon color='var(--gray-600)'/>
                </button>
              </div>
              {/* LEFT CONTENT */}
              <div className='flex flex-col gap-10 mt-10 mb-20'>
                <h3 className='text-b1-700 text-base'>기본 정보</h3>
                <table className='gray-table'>
                  <tr>
                    <th>이름</th>
                    <td>제주 EV 충전기 01</td>
                  </tr>
                  <tr>
                    <th>고유 식별자</th>
                    <td>EVO-1004</td>
                  </tr>
                  <tr>
                    <th>용량(kWh)</th>
                    <td>100</td>
                  </tr>
                </table>
              </div>
              
              <div className='flex flex-col gap-10 mt-10 mb-20'>
                <h3 className='text-b1-700 text-base'>충전소 정보</h3>
                <table className='gray-table'>
                  <tr>
                    <th>이름</th>
                    <td>제주 EV 충전소 01</td>
                  </tr>
                  <tr>
                    <th>고유 식별자</th>
                    <td>EMV0000</td>
                  </tr>
                  <tr>
                    <th>주소</th>
                    <td>제주시 서귀포시 중문동 123-1</td>
                  </tr>
                  <tr>
                    <th>계량기 계약번호</th>
                    <td>1234567890</td>
                  </tr>
                </table>
              </div>
              
              <div className='flex flex-col gap-10 mt-10 mb-20'>
                <h3 className='text-b1-700 text-base'>DR자원 정보</h3>
                <table className='gray-table'>
                  <tr>
                    <th>DR자원 이름</th>
                    <td>DR자원 A</td>
                  </tr>
                  <tr>
                    <th>DR자원 고유 식별자</th>
                    <td>DR0000</td>
                  </tr>
                  <tr>
                    <th>주소</th>
                    <td>제주시 서귀포시 중문동 123-1</td>
                  </tr>
                </table>
              </div>
              

            </div>
            <div className='detail-modal-content-divide-content right'>
              {/* RIGHT CONTENT */}
              <div className='flex flex-col gap-10 mb-20'>
                <h3 className='text-b1-700 text-base'>DR자원 정보</h3>
                <table className='gray-table'>
                  <tr>
                    <th>DR자원 이름</th>
                    <td>DR자원 A</td>
                  </tr>
                  <tr>
                    <th>DR자원 고유 식별자</th>
                    <td>DR0000</td>
                  </tr>
                  <tr>
                    <th>주소</th>
                    <td>제주시 서귀포시 중문동 123-1</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChargerDetailModal